import React from "react";
import { Navbar } from "./landing/Navbar";
import { Hero } from "./landing/Hero";
import { MisionVision } from "./landing/MisionVision";
import { LifestyleBanner } from "./landing/LifestyleBanner";
import { Valores } from "./landing/Valores";
import { CierreCTA } from "./landing/CierreCTA";

export default function LandingPage() {
    return (
        <div
            className="min-h-screen bg-white text-slate-800"
            data-testid="landing-page"
        >
            <Navbar />
            <main>
                <Hero />
                <MisionVision />
                <LifestyleBanner />
                <Valores />
                <CierreCTA />
            </main>
        </div>
    );
}
